import React from 'react';
import { useTranslation } from 'react-i18next';
import { Truck, CheckCircle, Clock, MapPin } from 'lucide-react';

/**
 * ShippingStats — four-tile KPI strip at the top of AdminShipping.
 *
 * Props:
 *   stats  { total, active, avgDeliveryTime, totalZones }
 */
const ShippingStats = ({ stats }) => {
  const { t } = useTranslation();

  return (
    <div className="stats-grid">
      <div className="stat-card">
        <div className="stat-icon" style={{ background: '#3b82f620', color: '#3b82f6' }}>
          <Truck size={24} />
        </div>
        <div className="stat-details">
          <p className="stat-label">{t('admin.shipping.stats.totalMethods')}</p>
          <p className="stat-value">{stats.total}</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon" style={{ background: '#10b98120', color: '#10b981' }}>
          <CheckCircle size={24} />
        </div>
        <div className="stat-details">
          <p className="stat-label">{t('admin.shipping.stats.activeMethods')}</p>
          <p className="stat-value">{stats.active}</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon" style={{ background: '#f59e0b20', color: '#f59e0b' }}>
          <Clock size={24} />
        </div>
        <div className="stat-details">
          <p className="stat-label">{t('admin.shipping.stats.avgDeliveryTime')}</p>
          <p className="stat-value">
            {stats.avgDeliveryTime.toFixed(1)} {t('admin.shipping.card.days')}
          </p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon" style={{ background: '#a855f720', color: '#a855f7' }}>
          <MapPin size={24} />
        </div>
        <div className="stat-details">
          <p className="stat-label">{t('admin.shipping.stats.zonesConfigured')}</p>
          <p className="stat-value">{stats.totalZones}</p>
        </div>
      </div>
    </div>
  );
};

export default ShippingStats;
